const minimumRepayment = 30;

export const calculateMonthlyRepayment = (creditLimit, rate = 2.75) => {
  if (creditLimit * (rate / 100) > minimumRepayment) {
    return Math.round(creditLimit * (rate / 100) * 100) / 100;
  }
  return minimumRepayment;
};
